(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inn-vjesalice-auto"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('inn-smooth-rail')) {
  customElements.define('inn-smooth-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const config = this.querySelector('[data-rail-config]');
      if (!config) return;
      this.config = JSON.parse(config.textContent);
      if (!this.config.collections.length) return;
      this.initialized = true;
      this.life = new AbortController();
      this.cache = this.cache || new Map();
      this.requestVersion = (this.requestVersion || 0) + 1;
      this.products = [];
      this.cards = [];
      this.currentCollection = 0;
      this.activeIndex = -1;
      this.activePhysical = -1;
      this.view = 0;
      this.lane = this.querySelector('[data-rail-lane]');
      this.dialog = this.querySelector('[data-rail-dialog]');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine)');
      this.ui = {};
      ['vendor','product-link','price','compare','sold','counter','prev','next','all','details','controls','status','retry'].forEach(key => this.ui[key] = this.querySelector('[data-rail-' + key + ']'));
      const opts = {signal:this.life.signal};
      this.addEventListener('click', e => this.onClick(e), opts);
      this.addEventListener('keydown', e => this.onKey(e), opts);
      this.addEventListener('focusin', e => {
        const item = e.target.closest('[data-physical]');
        if (item && !this.dialog.open) this.select(Number(item.dataset.physical));
      }, opts);
      this.lane.addEventListener('pointerover', e => {
        if (!this.hoverQuery.matches || this.motion || this.dragging || this.dialog.open) return;
        const item = e.target.closest('[data-physical]');
        if (item && !item.contains(e.relatedTarget)) this.select(Number(item.dataset.physical));
      }, opts);
      this.lane.addEventListener('scroll', () => {
        this.schedulePaint(true);
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 140);
      }, {passive:true,...opts});
      this.lane.addEventListener('scrollend', () => this.settle(), opts);
      this.lane.addEventListener('pointerdown', e => {
        this.cancelMove();
        this.dragging = true;
        this.pointerStart = {x:e.clientX,y:e.clientY,left:this.lane.scrollLeft};
        this.swiped = false;
      }, {passive:true,...opts});
      this.lane.addEventListener('pointermove', e => {
        if (this.pointerStart && (Math.abs(e.clientX-this.pointerStart.x)>8 || Math.abs(e.clientY-this.pointerStart.y)>8)) this.swiped = true;
      }, {passive:true,...opts});
      const release = () => {
        this.dragging = false;
        this.pointerStart = null;
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 180);
      };
      window.addEventListener('pointerup', release, opts);
      window.addEventListener('pointercancel', release, opts);
      this.lane.addEventListener('wheel', () => this.cancelMove(), {passive:true,...opts});
      this.querySelector('[data-modal-variant]').addEventListener('change', () => this.selectVariant(), opts);
      this.querySelector('[data-rail-form]').addEventListener('submit', e => {
        const select = this.querySelector('[data-modal-variant]');
        const variant = this.modalProduct?.variants.find(v => String(v.id) === select.value);
        if (!variant?.available) { e.preventDefault(); select.focus(); }
      }, opts);
      this.dialog.addEventListener('close', () => { this.modalProduct = null; }, opts);
      this.motionQuery.addEventListener('change', () => this.cancelMove(), opts);
      this.resizeObserver = new ResizeObserver(entries => {
        const width = Math.round(entries[0].borderBoxSize?.[0]?.inlineSize || this.clientWidth);
        if (width > 0 && width !== this.width) this.layout(width);
      });
      this.resizeObserver.observe(this);
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(0); }
        }, {rootMargin:'600px'});
        this.observer.observe(this);
      } else this.load(0);
    }
    disconnectedCallback() {
      this.life?.abort();
      this.feedRequest?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.cancelMove();
      cancelAnimationFrame(this.paintFrame);
      cancelAnimationFrame(this.layoutFrame);
      clearTimeout(this.settleTimer);
      this.requestVersion = (this.requestVersion || 0) + 1;
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
    async load(index, force = false) {
      const selected = this.config.collections[index];
      if (!selected) return;
      this.cancelMove();
      this.feedRequest?.abort();
      this.feedRequest = new AbortController();
      const version = ++this.requestVersion;
      this.currentCollection = index;
      this.activeIndex = -1;
      this.activePhysical = -1;
      this.view = 0;
      this.querySelectorAll('[data-collection]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.collection) === index)));
      this.ui.all.href = selected.url;
      this.ui.details.hidden = true;
      this.ui.controls.hidden = true;
      this.ui.retry.hidden = true;
      this.ui.status.textContent = this.config.strings.loading;
      this.lane.setAttribute('aria-busy','true');
      this.lane.replaceChildren();
      this.products = [];
      this.cards = [];
      try {
        let record = this.cache.get(selected.id);
        if (force || !record || Date.now()-record.time > 60000) {
          const url = new URL(selected.url, location.origin);
          url.searchParams.set('sort_by','created-descending');
          url.searchParams.set('page','1');
          url.searchParams.set('section_id','inn-vjesalice-auto');
          const preview = new URLSearchParams(location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          const response = await fetch(url,{credentials:'same-origin',signal:this.feedRequest.signal});
          if (!response.ok) throw new Error('Feed unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
          const feed = parsed.querySelector('[data-inn-rail-feed]');
          if (!feed) throw new Error('Feed missing');
          const data = JSON.parse(feed.textContent);
          if (String(data.collection_id)!==String(selected.id) || data.sort!=='created-descending' || !Array.isArray(data.products)) throw new Error('Feed mismatch');
          record = {products:data.products.slice(0,10),time:Date.now()};
          this.cache.set(selected.id,record);
        }
        if (version!==this.requestVersion || !this.isConnected) return;
        this.products = record.products;
        this.render();
      } catch(error) {
        if (error.name==='AbortError' || version!==this.requestVersion || !this.isConnected) return;
        this.ui.status.textContent = this.config.strings.error;
        this.ui.retry.hidden = false;
      } finally {
        if (version===this.requestVersion) this.lane.setAttribute('aria-busy','false');
      }
    }
    render() {
      const count = this.products.length;
      this.loop = count >= 5;
      this.ui.status.textContent = count ? '' : this.config.strings.empty;
      this.ui.details.hidden = !count;
      this.ui.controls.hidden = count < 2;
      if (!count) return;
      const template = this.querySelector('[data-rail-card]');
      const fragment = document.createDocumentFragment();
      this.cards = [];
      for (let physical=0;physical<count*(this.loop?3:1);physical++) {
        const index = physical%count;
        const product = this.products[index];
        const el = template.content.firstElementChild.cloneNode(true);
        el.dataset.physical = String(physical);
        el.dataset.productIndex = String(index);
        el.classList.toggle('has-side',Boolean(product.images[2]));
        el.setAttribute('aria-posinset',String(index+1));
        el.setAttribute('aria-setsize',String(count));
        el.setAttribute('aria-hidden','true');
        const button = el.querySelector('button');
        button.tabIndex = -1;
        button.setAttribute('aria-label',product.title+', '+this.productPrice(product));
        button.setAttribute('aria-pressed','false');
        el.querySelector('[data-card-price]').textContent = this.productPrice(product);
        this.cards.push({el,button,photo:el.querySelector('.inn-fit__photo'),index,physical,loaded:false,view:0});
        fragment.append(el);
      }
      this.lane.replaceChildren(fragment);
      this.activeIndex = Math.min(1,count-1);
      this.layout(this.clientWidth,true);
    }
    layout(width, first = false) {
      if (!width) return;
      this.cancelMove();
      cancelAnimationFrame(this.paintFrame);
      this.paintFrame = 0;
      this.selectCenter = false;
      this.reflow = true;
      this.lane.classList.add('is-moving');
      this.width = width;
      const base = width < 750 ? 4 : width < 1100 ? 6 : 8;
      this.slots = this.loop ? Math.min(base,this.products.length-1) : base;
      this.step = width/this.slots;
      this.rodHeight = width < 750 ? 26 : width < 1100 ? 40 : 54;
      this.photoWidth = Math.min(260,this.step*1.35);
      const photoHeight = Math.min(365,this.step*2.1);
      this.style.setProperty('--step',this.step+'px');
      this.style.setProperty('--photo-width',this.photoWidth+'px');
      this.style.setProperty('--photo-height',photoHeight+'px');
      this.style.setProperty('--rod-height',this.rodHeight+'px');
      this.style.setProperty('--lane-height',(photoHeight+this.rodHeight+8)+'px');
      this.style.setProperty('--rail-pad',this.loop?(width-this.step)/2+'px':'0px');
      this.lane.classList.toggle('is-short',!this.loop);
      this.cards.forEach(card => {
        if (card.side) card.side.sizes = this.photoWidth+'px';
        if (card.face) card.face.sizes = this.photoWidth+'px';
      });
      if (!this.products.length) { this.reflow = false; this.lane.classList.remove('is-moving'); return; }
      if (first && width >= 750) this.activeIndex = Math.min(Math.floor((this.slots-1)/2),this.products.length-1);
      const physical = (this.loop ? this.products.length : 0) + Math.max(0,this.activeIndex);
      this.lane.scrollLeft = this.loop ? physical*this.step : 0;
      this.paint();
      this.select(physical);
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        this.lane.scrollLeft = this.loop ? physical*this.step : 0;
        this.lane.classList.remove('is-moving');
        this.reflow = false;
        this.paint();
      });
    }
    schedulePaint(selectCenter = false) {
      this.selectCenter = this.selectCenter || selectCenter;
      if (this.paintFrame) return;
      this.paintFrame = requestAnimationFrame(() => {
        this.paintFrame = 0;
        const select = this.selectCenter;
        this.selectCenter = false;
        this.paint();
        if (select && this.loop && !this.dialog.open && !this.reflow) this.select(Math.max(0,Math.min(this.cards.length-1,Math.round(this.lane.scrollLeft/this.step))));
      });
    }
    paint() {
      if (!this.cards.length || !this.step) return;
      const position = this.loop ? this.lane.scrollLeft/this.step : (this.products.length-1)/2;
      const core = (this.slots-2)/2;
      this.cards.forEach(card => {
        const distance = card.physical-position;
        const abs = Math.abs(distance);
        const x = .5+distance/this.slots;
        const t = Math.max(0,Math.min(1,x));
        const drop = (16+360*t*(1-t))*this.rodHeight/130;
        const opacity = !this.loop ? 1 : abs <= core+.1 ? 1 : Math.max(.38,1-(abs-core-.1)*.70);
        card.el.style.setProperty('--drop',drop.toFixed(2)+'px');
        card.el.style.setProperty('--fade',opacity.toFixed(3));
        const visible = abs < (this.slots+1)/2;
        card.el.setAttribute('aria-hidden',String(!visible));
        if (abs < (this.slots+3)/2) this.prepareCard(card);
      });
    }
    prepareCard(card) {
      if (card.loaded) return;
      card.loaded = true;
      const product = this.products[card.index];
      const side = product.images[2] || product.images[0];
      if (!side) {
        const placeholder = document.createElement('span');
        placeholder.className = 'inn-fit__placeholder';
        placeholder.textContent = this.config.strings.missing;
        card.photo.append(placeholder);
        return;
      }
      card.side = this.makeImage(side,'inn-fit__side');
      card.face = this.makeImage(product.images[0] || side,'inn-fit__face');
      card.face.addEventListener('load',()=>card.photo.classList.add('is-ready'));
      card.face.addEventListener('error',()=>card.photo.classList.remove('is-ready'));
      card.photo.append(card.side,card.face);
      if (card.face.complete && card.face.naturalWidth) card.photo.classList.add('is-ready');
    }
    makeImage(source, className) {
      const img = new Image(source.width || 600,source.height || 750);
      img.alt = '';
      img.className = className;
      img.decoding = 'async';
      img.loading = 'eager';
      this.setImageSource(img,source);
      return img;
    }
    setImageSource(img,source,large = false) {
      const url = large ? source.large : source.src;
      if (img.dataset.source === url) return;
      img.dataset.source = url;
      img.sizes = large ? '(max-width: 749px) 88vw, 460px' : this.photoWidth+'px';
      img.srcset = source.small && source.medium ? source.small+' 240w, '+source.medium+' 360w, '+source.src+' 600w'+(large?', '+source.large+' 1100w':'') : '';
      img.src = url;
    }
    productPrice(product) { return product.price_varies ? this.config.strings.from+' '+product.min_price_text : product.price_text; }
    select(physical) {
      const card = this.cards[physical];
      if (!card || this.dialog.open || (physical===this.activePhysical && card.view===this.view)) return;
      const previous = this.cards[this.activePhysical];
      if (previous) {
        previous.el.classList.remove('is-active');
        previous.button.setAttribute('aria-pressed','false');
        previous.button.tabIndex = -1;
      }
      if (card.index !== this.activeIndex) this.view = 0;
      this.activePhysical = physical;
      this.activeIndex = card.index;
      this.prepareCard(card);
      this.showCardView(card,this.view);
      card.el.classList.add('is-active');
      card.button.setAttribute('aria-pressed','true');
      card.button.tabIndex = 0;
      const product = this.products[card.index];
      this.ui.vendor.textContent = product.vendor;
      this.ui['product-link'].textContent = product.title;
      this.ui['product-link'].href = product.url;
      this.ui.price.textContent = this.productPrice(product);
      this.ui.compare.hidden = product.price_varies || !(product.compare > product.price);
      this.ui.compare.textContent = product.compare_text;
      this.ui.compare.parentElement.classList.toggle('is-sale',!this.ui.compare.hidden);
      this.ui.sold.hidden = product.available;
      this.ui.counter.textContent = String(card.index+1).padStart(2,'0')+' / '+String(this.products.length).padStart(2,'0');
      this.ui.prev.disabled = this.products.length<2 || (!this.loop && card.index===0);
      this.ui.next.disabled = this.products.length<2 || (!this.loop && card.index===this.products.length-1);
      this.updateViewButtons('[data-rail-view]','railView',this.view);
    }
    showCardView(card,index) {
      const source = this.products[card.index].images[index];
      if (!source || !card.face) return;
      if (card.face.dataset.source !== source.src) {
        card.photo.classList.remove('is-ready');
        this.setImageSource(card.face,source);
        if (card.face.complete && card.face.naturalWidth) card.photo.classList.add('is-ready');
      }
      card.view = index;
    }
    cancelMove() {
      cancelAnimationFrame(this.moveFrame);
      this.motion = false;
      this.targetPhysical = null;
      this.lane?.classList.remove('is-moving');
    }
    moveTo(physical) {
      physical = Math.max(0,Math.min(this.cards.length-1,physical));
      if (!this.loop) { this.select(physical); return; }
      this.cancelMove();
      const from = this.lane.scrollLeft;
      const to = physical*this.step;
      if (this.motionQuery.matches || Math.abs(to-from)<1) {
        this.lane.scrollLeft = to;
        this.paint();
        this.select(physical);
        this.settle();
        return;
      }
      this.targetPhysical = physical;
      this.motion = true;
      this.lane.classList.add('is-moving');
      const start = performance.now();
      const tick = now => {
        const progress = Math.min(1,(now-start)/190);
        this.lane.scrollLeft = from+(to-from)*(1-Math.pow(1-progress,3));
        if (progress < 1) this.moveFrame = requestAnimationFrame(tick);
        else {
          this.motion = false;
          this.targetPhysical = null;
          this.lane.classList.remove('is-moving');
          this.select(physical);
          this.settle();
        }
      };
      this.moveFrame = requestAnimationFrame(tick);
    }
    settle() {
      if (!this.loop || this.motion || this.reflow || this.dragging || this.dialog.open || !this.cards.length) return;
      const position = this.lane.scrollLeft/this.step;
      const physical = Math.round(position);
      if (Math.abs(position-physical)>.04) return;
      const count = this.products.length;
      if (physical < count || physical >= count*2) {
        const canonical = count+((physical%count)+count)%count;
        this.lane.scrollLeft += (canonical-physical)*this.step;
        this.paint();
        this.select(canonical);
      }
    }
    image(container, source, alt) {
      if (!source) {
        const placeholder = document.createElement('span');
        placeholder.className = 'inn-fit__placeholder';
        placeholder.textContent = this.config.strings.missing;
        container.replaceChildren(placeholder);
        return;
      }
      let img = container.querySelector('img');
      if (!img) { img = new Image(source.width || 600,source.height || 750); img.decoding = 'async'; container.replaceChildren(img); }
      img.alt = alt;
      this.setImageSource(img,source,true);
    }
    updateViewButtons(selector,key,view) {
      const product = selector.includes('modal') ? this.modalProduct : this.products[this.activeIndex];
      if (!product) return;
      this.querySelectorAll(selector).forEach(button => {
        const i = Number(button.dataset[key]);
        button.disabled = !product.images[i];
        button.setAttribute('aria-pressed',String(i===view));
      });
    }
    changeView(index,modal = false) {
      const product = modal ? this.modalProduct : this.products[this.activeIndex];
      if (!product?.images[index]) return;
      if (modal) {
        this.image(this.querySelector('[data-rail-modal-image]'),product.images[index],product.title);
        this.updateViewButtons('[data-modal-view]','modalView',index);
      } else {
        this.view = index;
        this.showCardView(this.cards[this.activePhysical],index);
        this.updateViewButtons('[data-rail-view]','railView',index);
      }
    }
    openProduct() {
      const product = this.products[this.activeIndex];
      if (!product) return;
      this.cancelMove();
      this.modalProduct = product;
      if (typeof this.dialog.showModal !== 'function') { location.assign(product.url); return; }
      this.querySelector('[data-modal-vendor]').textContent = product.vendor;
      this.querySelector('[data-modal-title]').textContent = product.title;
      this.querySelector('[data-modal-price]').textContent = this.productPrice(product);
      const compare = this.querySelector('[data-modal-compare]');
      compare.textContent = product.compare_text;
      compare.hidden = product.price_varies || !(product.compare>product.price);
      compare.parentElement.classList.toggle('is-sale',!compare.hidden);
      this.querySelector('[data-modal-link]').href = product.url;
      this.image(this.querySelector('[data-rail-modal-image]'),product.images[this.view] || product.images[0],product.title);
      this.updateViewButtons('[data-modal-view]','modalView',this.view);
      this.querySelector('[data-rail-form]').hidden = !product.available || product.requires_plan;
      this.querySelector('[data-modal-sold]').hidden = product.available;
      const select = this.querySelector('[data-modal-variant]');
      select.replaceChildren(new Option(this.config.strings.choose,''));
      select.options[0].disabled = true;
      select.options[0].selected = true;
      product.variants.forEach(variant => {
        const name = product.single_variant ? this.config.strings.one_size : variant.title;
        const option = new Option(name+(variant.available?'':' — '+this.config.strings.sold),String(variant.id));
        option.disabled = !variant.available;
        select.add(option);
      });
      if (product.single_variant && product.variants[0]?.available) select.value = String(product.variants[0].id);
      this.selectVariant();
      this.dialog.showModal();
    }
    selectVariant() {
      const product = this.modalProduct;
      const variant = product?.variants.find(v => String(v.id)===this.querySelector('[data-modal-variant]').value);
      this.querySelector('[data-modal-add]').disabled = !variant?.available;
      if (!variant) return;
      this.querySelector('[data-modal-price]').textContent = variant.price_text;
      const compare = this.querySelector('[data-modal-compare]');
      compare.textContent = variant.compare_text;
      compare.hidden = !(variant.compare>variant.price);
      compare.parentElement.classList.toggle('is-sale',!compare.hidden);
      const link = new URL(product.url,location.origin);
      link.searchParams.set('variant',variant.id);
      this.querySelector('[data-modal-link]').href = link.pathname+link.search;
    }
    onClick(event) {
      if (event.target===this.dialog) {
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close();
        return;
      }
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled) return;
      if (button.hasAttribute('data-collection')) { this.load(Number(button.dataset.collection)); return; }
      if (button.hasAttribute('data-rail-retry')) { this.load(this.currentCollection,true); return; }
      if (button.hasAttribute('data-rail-prev') || button.hasAttribute('data-rail-next')) {
        const direction = button.hasAttribute('data-rail-next') ? 1 : -1;
        this.moveTo((this.targetPhysical ?? this.activePhysical)+direction);
        return;
      }
      if (button.hasAttribute('data-rail-view')) { this.changeView(Number(button.dataset.railView)); return; }
      if (button.hasAttribute('data-modal-view')) { this.changeView(Number(button.dataset.modalView),true); return; }
      if (button.hasAttribute('data-rail-close')) { this.dialog.close(); return; }
      if (button.hasAttribute('data-rail-open')) { this.openProduct(); return; }
      const item = button.closest('[data-physical]');
      if (!item) return;
      if (this.swiped) { this.swiped = false; return; }
      const physical = Number(item.dataset.physical);
      const centered = !this.loop || Math.abs(physical-this.lane.scrollLeft/this.step)<.15;
      if (this.hoverQuery.matches || centered) { this.select(physical); this.openProduct(); }
      else this.moveTo(physical);
    }
    onKey(event) {
      const item = event.target.closest('[data-physical]');
      if (!item || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const base = this.loop ? this.products.length : 0;
      let physical = this.targetPhysical ?? this.activePhysical;
      if (event.key==='Home') physical = base;
      else if (event.key==='End') physical = base+this.products.length-1;
      else physical += event.key==='ArrowRight'?1:-1;
      physical = Math.max(0,Math.min(this.cards.length-1,physical));
      this.moveTo(physical);
      this.cards[physical].button.focus({preventScroll:true});
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
